module.exports = __webpack_public_path__ + "img/butterfly.03490f5e.gif";